import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState, } from 'react';
import { styled } from '@mui/material';
import { InputAdornment, TextField as MuiTextField, IconButton, Box, } from '@mui/material';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import CloseIcon from '@mui/icons-material/Close';
import { Label1 } from '../../atoms/typography';
const MarginedTextField = styled(MuiTextField) `
  margin-bottom: ${({ helperText }) => (helperText ? '0px' : '23px')}
`;
const Instructions = styled(Label1) `
  margin-bottom: 5px;
`;
const Scanner = ({ autoFocus = false, className = '', hasError = false, helperText = '', icon = undefined, instructionText = '', label = '', onScannerChange = undefined, onClear = undefined, onEnter = undefined, placeholder = '', showIcon = false, value = undefined, inputRef: providedInputRef, disabled = false, includeBottomMargin = true, ...muiProps }) => {
    const internalInputRef = useRef(null);
    const inputRef = providedInputRef ?? internalInputRef;
    const [inputValue, setInputValue] = useState('');
    const handleChange = (event) => {
        if (disabled) {
            return;
        }
        onScannerChange?.(event);
        setInputValue(event.target.value);
    };
    const handleEnter = (event) => {
        if (disabled) {
            return;
        }
        onEnter?.(event);
    };
    const handleClear = (event) => {
        if (disabled) {
            return;
        }
        onClear?.(event);
        setInputValue('');
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };
    const handleKeyDown = (event) => {
        if (event?.code?.includes('Enter')) {
            handleEnter(event);
        }
    };
    const TextField = includeBottomMargin ? MarginedTextField : MuiTextField;
    return (_jsxs(Box, { className: `scanner ${className}`, ...muiProps, children: [instructionText && (_jsx(Instructions, { children: instructionText })), _jsx(TextField, { className: "scanner__input", disabled: disabled, inputRef: inputRef, autoFocus: autoFocus, error: hasError, helperText: helperText, label: label, inputProps: {
                    'data-testid': label,
                }, onChange: handleChange, onKeyDown: handleKeyDown, placeholder: placeholder, variant: "outlined", fullWidth: true, value: value ?? inputValue, InputProps: {
                    startAdornment: showIcon && (_jsx(InputAdornment, { position: "start", children: icon ?? _jsx(QrCodeScannerIcon, {}) })),
                    endAdornment: (value || inputValue) && (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { size: "small", onClick: handleClear, "data-testid": "scanner-clear-button", children: _jsx(CloseIcon, {}) }) }))
                } })] }));
};
export default Scanner;
//# sourceMappingURL=index.js.map